import { isVendorAdminUser } from './authentication';
import { isSubClientAccount } from './dentistPortal';
import { isCustomUserTypeName } from './translateCatalog';

const resolveUserTypeName = (user) =>
    String(user?.user_type_name ?? user?.userType?.name ?? user?.user_type?.name ?? '')
        .toLowerCase();

/** Lab-floor staff that work on cases but never handle money. */
const PRICE_BLIND_STAFF_TYPES = ['technician', 'courier', 'designer', 'scanner'];

const userHasPermission = (user, name) =>
    (user?.permissions ?? []).some((permission) => (permission?.name ?? permission) === name);

/** Lab-defined roles see prices only when the role includes invoice access. */
const isPriceBlindCustomRole = (user) =>
    isCustomUserTypeName(resolveUserTypeName(user)) && !userHasPermission(user, 'view_invoice');

export const isTechnicianUser = (user) => resolveUserTypeName(user) === 'technician';

/** Technicians must not see who ordered: client and dentist names are hidden (and redacted by the API). */
export const shouldHideClientIdentity = (user) => isTechnicianUser(user);

/** Dentists and price-blind staff do not see pricing / additional-cost order summary panels. */
export const shouldHideOrderSummary = (user) => {
    const type = resolveUserTypeName(user);
    return type === 'dentist' || PRICE_BLIND_STAFF_TYPES.includes(type) || isPriceBlindCustomRole(user);
};

/** Price-blind staff and sub client accounts must not see order cost or invoice columns / links. */
export const shouldHideOrderCostAndInvoice = (user) => {
    const type = resolveUserTypeName(user);
    return PRICE_BLIND_STAFF_TYPES.includes(type) || isPriceBlindCustomRole(user) || isSubClientAccount(user);
};

/** Only admins see the order actions side panel on order pages. */
export const shouldHideOrderActionsPanel = (user) => !isVendorAdminUser(user);
